import { Link } from 'react-router'
import CfSectionShell from '../cf-section-shell'

import clsx from 'clsx'

import type { CfSectionShellFields } from '../cf-section-shell'

import { Blobby } from '~/components-v2/blobby/blobby'
import { contentfulImage } from '~/utils/contentful-image'

export type CtaBandFields = {
  headline: string
  subHeadline: string
  buttonText: string
  buttonUrl: string
  image?: {
    fields?: {
      file?: {
        url?: string
      }
      title?: string
    }
  }
}

interface CfCtaBandSectionProps {
  fields: CfSectionShellFields & CtaBandFields
}

export function CfCtaBandSection({ fields }: CfCtaBandSectionProps) {
  const { id, paddingTop, paddingBottom, showBottomBorder, theme } = fields
  const { headline, subHeadline, buttonText, buttonUrl, image } = fields
  const imageUrl = contentfulImage(image?.fields?.file?.url, { w: 1200 })
  const imageAlt = image?.fields?.title || 'CTA image'
  const hasImage = Boolean(imageUrl)

  return (
    <CfSectionShell
      id={id}
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      showBottomBorder={showBottomBorder}
      theme={theme}
    >
      <section className={clsx('stack cta-band')}>
        {hasImage ? (
          <img
            className="cta-band-image"
            src={imageUrl}
            alt={imageAlt}
            loading="lazy"
          />
        ) : (
          <Blobby expression="excited" />
        )}

        {typeof headline === 'string' ? (
          <hgroup className="centered-section-title">
            <h3>{headline}</h3>
            {subHeadline && <p>{subHeadline}</p>}
          </hgroup>
        ) : null}

        {buttonText && (
          <Link className={clsx('call-to-action', 'primary')} to={buttonUrl}>
            {buttonText}
          </Link>
        )}
      </section>
    </CfSectionShell>
  )
}
